import React from 'react'; 
import { Switch, Route } from 'react-router-dom';
import Mappy from './map/Mappy';
import Navbar from './navbar/Navbar';
import Register from './register/Register';
import Login from './login/Login';
import MonProfil from './monProfil/MonProfil';
import AllEvents from './allEvents/AllEvents'
import Bottom from './bottomNav/BottomNav';
import AddEvent from './addEvent/AddEvent';
import ListEvent from './listEvent/ListEvent';
import Interet from './interet/Interet'
import Carousel from './map/Carousel';

const Router = () => {

    return(
        <>
        <Navbar />
            <Switch>
                <Route exact path="/" component={Carousel}/>
                <Route exact path="/mappy" component={Mappy}/>
                <Route exact path="/listEvent" component={ListEvent}/>
                <Route exact path='/register' component={Register} />
                <Route exact path="/login" component={Login}/>
                <Route exact path='/monProfil' component={MonProfil} />
                <Route exact path='/monProfil/:fbId' component={MonProfil} />
                <Route exact path="/addEvent" component={AddEvent}/>
                <Route exact path="/allEvents" component={AllEvents}/>
                <Route exact path="/interet" component={Interet}/>



            </Switch>            
            <Bottom/>
        </>
    )
}

export default Router;